import { Injectable } from "@angular/core";

import { BehaviorSubject, Observable } from "rxjs";
import { HhsgSharedNavHeader } from "../models/nav-header.model";
import { HhsgSharedNavMenuItem } from "../models/nav-menu-item.model";

@Injectable({
    providedIn: 'root'
})
export class HhsgSharedNavHeaderService {
    private navHeaderSelected = new BehaviorSubject<HhsgSharedNavHeader>(null);
    navHeaderSelected$: Observable<HhsgSharedNavHeader> = this.navHeaderSelected.asObservable();

    private navMenuItemSelected = new BehaviorSubject<HhsgSharedNavMenuItem>(null);
    navMenuItemSelected$: Observable<HhsgSharedNavMenuItem> = this.navMenuItemSelected.asObservable();

    constructor() {

    }
    
    announceNavHeaderSelected(header: HhsgSharedNavHeader) {
        this.navHeaderSelected.next(header);
    }

    announceNavMenuItemSelected(menuItem: HhsgSharedNavMenuItem) {
        this.navMenuItemSelected.next(menuItem);
    }
}